import { SHOW_BLOG, SHOW_PARTNERS } from '../../config/featureFlags';

// Routes where the site footer is suppressed.
// - Auth flows: chrome-free focus on the form
// - Onboarding: full-screen guarded flow
// - Admin: internal tool, has its own AdminLayout chrome
export const FOOTER_HIDDEN_PREFIXES = [
  '/login',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
  '/onboarding',
  '/oauth/callback',
  '/admin',
];

// Admin dropdown menu items
export const adminMenuItems = [
  { label: 'Admin Dashboard', path: '/admin/dashboard' },
  { label: 'Admin Feedback', path: '/admin/feedback' },
  { label: 'Admin Media', path: '/admin/media' },
  { label: 'Admin Test', path: '/admin/media-test' },
];

// "More" dropdown menu items — secondary nav surfaces parked here.
// An item is either a link ({ label, path }) or a divider ({ hr: true }).
export type MoreMenuItem = { label: string; path: string } | { hr: true };

export const moreMenuItems: MoreMenuItem[] = [
  { label: 'Wines', path: '/wines' },
  { label: 'Check-in Leader Board', path: '/check-in-leaderboard' },
  { label: 'Latest Reviews', path: '/latest-reviews' },
  { hr: true },
  { label: 'Wine Tasting FAQs', path: '/wine-tasting-faq' },
  ...(SHOW_BLOG
    ? ([{ label: 'WineryXplorer Blog', path: '/wineryxplorer-blog' }] as MoreMenuItem[])
    : []),
  ...(SHOW_PARTNERS
    ? ([{ label: 'Partners', path: '/partners' }] as MoreMenuItem[])
    : []),
  { hr: true },
  { label: 'Help', path: '/help' },
  { label: 'Feedback / Report Errors', path: '/report-errors' },
  { hr: true },
  { label: 'About WineryXplorer', path: '/about' },
];
